import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-lead-approved',
  templateUrl: './lead-approved.component.html'
})
export class LeadApprovedComponent implements OnInit {
  isError = false;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.isError = params['error'] === '1';
    });
  }
}
